import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, AsyncSelect } from '../../ui';
import pymeImage from '../../../assets/pyme/pyme.png';
import { setClientValue } from "../../../actions";
import { options } from "../../../operations";
import { Title, Body } from '../../Common/Form';
import Continue from "../../Common/Continue";
import Text from '../../Common/Form/Text';
import { getStreetsAsync } from '../../../operations/options';

import iconHouse from '../../../assets/icons/icon-house.svg';

class PymeForm_3 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
    };

    this.continueCondition = this.continueCondition.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount() {
    this.checkContinueState(null);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const {
      addressCity,
      addressStreet,
      addressNumber,
      addressApto
    } = this.props;

    return (
      addressCity   != null &&
      addressStreet != null &&
      addressNumber != ''   &&
      addressApto
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getContent() {

    const {
      addressStreet,
      showError,
      onValueChange,
      addressState,
      addressCity,
      addressNumber,
      addressApto
    } = this.props;

    return (
      <div>
        <Text className="Text-question">
          ¿En que calle se encuentra tu PYME?
        </Text>

        <AsyncSelect
          name="street"
          value={addressStreet}
          leftIcon={iconHouse}
          errorClass={showError && !addressStreet ? 'ErrorDisplayBorder' : ''}
          onChange={(value) => { onValueChange('addressStreet', value) }}
          placeholder="Seleccione una calle"
          searchPromptText="Escriba para buscar su calle"
          loadOptions={(inputValue) => getStreetsAsync(addressState, addressCity, inputValue)}
          disabled={(!addressCity)}
        />

        <Text style={{ paddingTop: '25px'}} className="Text-question">
          ¿Cual es el número de puerta?
        </Text>

        <Input
          id="addressNumber"
          name="addressNumber"
          //placeholder="ej. 1234"
          maxLength="50"
          type="text"
          value={addressNumber}
          onChange={(event) => { onValueChange('addressNumber', event.target.value) }}
          leftIcon={iconHouse}
          showAlert={showError && !addressNumber}
          autoComplete="nope"
        />
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          ¿Cual es el número de apartamento o referencia?
        </Text>
        <Input
          id="addressApto"
          name="addressApto"
          //placeholder="ej. 203"
          maxLength="50"
          type="text"
          value={addressApto}
          onChange={(event) => { onValueChange('addressApto', event.target.value) }}
          leftIcon={iconHouse}
          showAlert={showError && !addressApto}
          autoComplete="nope"
        />
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;

    return (
      <div>
        <div className="Pyme-Form">
          <div className="Pyme-Form-icon">
            <img src={pymeImage} alt="pyme" />
          </div>
          <div>
            <div className="Pyme-Form-wrapper">
              <Body columnContent={this.getContent} />
            </div>
          </div>
        </div>
        <Continue state={toContinue} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    addressState: state.client.addressState,
    addressCity: state.client.addressCity,
    addressStreet: state.client.addressStreet,
    addressNumber: state.client.addressNumber,
    addressApto: state.client.addressApto,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    getStreets: (val, callback) => {
      dispatch(options.getStreets(val, callback));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PymeForm_3);